export default __webpack_public_path__ + "static/media/mort2.25f975ef.png";